import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalTitle,
} from '@readcloud/component-library';
import React from 'react';
import {
  SelectableObjectItem,
  SelectableObjectsList,
} from './SelectableObjectsList';

interface Props {
  iconLabel: string;
  title: string;
  shareWith?: string;
  selectedItems: Array<string>;
  items: SelectableObjectItem[];
  onChange: (items: Array<string>) => void;
  icon: React.ReactNode;
  forceClose?: boolean;
}

interface State {
  open: boolean;
}

/**
 * This is a convenience button component that is used to manage annotation visibility/sharing
 *  - It will render a labelled icon button, that when clicked will show a popover containing a SelectableObjectsList
 *  - The forceClose prop is used to force close the popover if it is open. This was added due to some limitations with the 'formik' library. It may not be necessary any more.
 *    - Used in the AnnotationDialog component in the Reader project
 */
export const SharingManagerButton: React.FC<Props> = (props) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const toggle = () => {
    setIsOpen((s) => !s);
  };

  return (
    <>
      <label
        htmlFor="shared"
        className="rc-flex rc-flex-col rc-items-center rc-whitespace-nowrap"
      >
        <Button variant="primary" size="sm" onClick={toggle}>
          {props.icon}
          <sup>{props.selectedItems?.length}</sup>
        </Button>
        <small>{props.iconLabel}</small>
      </label>

      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader>
          <ModalTitle>{props.title}</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <SelectableObjectsList
            selectAllObjectName={props.shareWith}
            selectedItems={props.selectedItems}
            items={props.items}
            setSelectedItems={props.onChange}
          />
        </ModalBody>
      </Modal>
    </>
  );
};
